import { useDrawer } from "@silversea-ssc/ui-components-react";
import React, {
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo
} from "react";
import { ActualShorexSelectionDrawerProps } from "./ShorexSelectionDrawer/ActualShorexSelectionDrawer";
const ActualShorexSelectionDrawer = React.lazy(
  () => import("./ShorexSelectionDrawer/ActualShorexSelectionDrawer")
);

type ShorexSelectionDrawerContextValue = {
  onShorexSelectionClick?: () => void;
};

const ShorexSelectionDrawerContext =
  React.createContext<ShorexSelectionDrawerContextValue>({
    onShorexSelectionClick: undefined
  });

type InternalInfographcInfo = boolean;

type Props = Omit<
  ActualShorexSelectionDrawerProps,
  "isOpen" | "onRequestClose"
>;

export const ShorexSelectionDrawerProvider: React.FC<
  PropsWithChildren<Props>
> = ({ children, ...props }) => {
  const {
    closeDrawer,
    drawerData,
    isDrawerMountable,
    isDrowerOpen,
    openDrawer
  } = useDrawer<InternalInfographcInfo>(undefined);

  const onShorexSelectionClick = useCallback(() => {
    openDrawer(true);
  }, [openDrawer]);

  const contextValue = useMemo(() => {
    return {
      onShorexSelectionClick
    };
  }, [onShorexSelectionClick]);

  return (
    <ShorexSelectionDrawerContext.Provider value={contextValue}>
      {children}
      {isDrawerMountable && drawerData && (
        <React.Suspense>
          <ActualShorexSelectionDrawer
            isOpen={isDrowerOpen}
            onRequestClose={closeDrawer}
            {...props}
          />
        </React.Suspense>
      )}
    </ShorexSelectionDrawerContext.Provider>
  );
};

export const useShorexSelectionDrawer = () => {
  return useContext(ShorexSelectionDrawerContext);
};
